import React, { useState, useEffect } from "react";
import { Form, Select, Button, Row, Col, notification } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const FirmApprovalAssignmentAddForm = ({ firmId, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    getApprovalRoles();
    getTenantUsers();
  }, []);

  const getApprovalRoles = () => {
    RequestHandler.get(`/FirmApprovalRoleAssignment/GetApprovalRoles`)
      .then((res) => {
        if (res.success && res.data) {
          setRoles(res.data);
        }
      })
      .catch(() => {});
  };

  const getTenantUsers = () => {
    RequestHandler.get(`/TenantUser?$count=true&$skip=0`)
      .then((res) => {
        if (res?.value) {
          // sadece aktif kullanıcılar gelsin
          const activeUsers = res.value.filter(
            (x) => x.isActive && !x.isDeleted
          );
          setUsers(activeUsers);
        }
      })
      .catch(() => {});
  };

  const onFinish = (values) => {
    setLoading(true);
    const payload = {
      ...values,
      firmId: firmId,
      tenantUserId: values.tenantUserId,
    };

    RequestHandler.post(`/FirmApprovalRoleAssignment`, payload).then((res) => {
      setLoading(false);
      if (res.success) {
        form.resetFields();
        onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      {/* Kullanıcı seçimi */}
      <Row style={{ marginTop: "5%" }}>
        <Col span={24}>
          <Form.Item
            label="Kullanıcı"
            name="tenantUserId"
            rules={[{ required: true, message: "Lütfen kullanıcı seçiniz." }]}
          >
            <Select
              placeholder="Kullanıcı seçiniz"
              showSearch
              allowClear
              filterOption={(input, option) => {
                // children bazen string dizisi bazen ReactNode olabilir, hepsini string'e çeviriyoruz
                const text = Array.isArray(option.children)
                  ? option.children.join("") // ["Fatih"," ","Akarsu"," (","fatih.a@aaa.com",")"] → "Fatih Akarsu (fatih.a@aaa.com)"
                  : option.children?.toString() || "";

                return text
                  .toLocaleLowerCase("tr-TR")
                  .includes(input.toLocaleLowerCase("tr-TR"));
              }}
            >
              {users.map((u) => (
                <Select.Option key={u.id} value={u.id}>
                  {u.firstName} {u.lastName} ({u.email})
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {/* Rol seçimi */}
          <Form.Item
            label="Onay Rolü"
            name="approvalRole"
            rules={[{ required: true, message: "Lütfen rol seçiniz." }]}
          >
            <Select placeholder="Onay rolü seçiniz" allowClear>
              {roles.map((r) => (
                <Select.Option key={r.id} value={r.id}>
                  {r.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Row justify="space-between">
            <Col></Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default FirmApprovalAssignmentAddForm;
